import React from "react";
import "../styles/VideoPlayerSidebar.css";

const VideoPlayerSidebar = ({ activeItem, setActiveItem, menuItems, resetSearch }) => {
  const handleItemClick = (item) => {
    // Only allow clicks on non-disabled items
    if (!item.disabled) {
      setActiveItem(item.key);
      if (item.key === "home") {
        resetSearch(); // Reset search when Home is clicked
      }
    }
  };

  return (
    <div className="videoPlayer-left-content">
      <aside className="videoPlayer-sidebar">
        <nav>
          <ul>
            {menuItems.map((item) => (
              <li
                key={item.key}
                className={`${activeItem === item.key ? "active" : ""} ${
                  item.disabled ? "disabled" : ""
                }`}
                onClick={() => handleItemClick(item)}
              >
                <div className="videoPlayer-menu-icon">
                  {typeof item.icon === "string" ? (
                    <img src={item.icon} alt={`${item.label} Icon`} />
                  ) : (
                    item.icon
                  )}
                </div>
                {/* <div className="sidebar-label">{item.label}</div> */}
              </li>
            ))}
          </ul>
        </nav>
      </aside>
    </div>
  );
};

export default VideoPlayerSidebar;
